const whiteSpace = {
    name: "white-space",
    path: "/white-space",
    title: "white-space",
    description: "Utilities for controlling how whitespace and line breaks inside an element are handled.",
    value: {
        "white-space": {
            "whitespace-normal": "normal",
            "whitespace-nowrap": "nowrap",
            "whitespace-pre": "pre",
            "whitespace-pre-line": "pre-line",
            "whitespace-pre-wrap": "pre-wrap",
            "whitespace-break-spaces": "break-spaces"
        }
    },
    exampleData: [
        {
            example: {
                code: `
<p class="whitespace-normal">The   quick brown fox
jumps over the lazy dog.</p>
<p class="whitespace-nowrap">The   quick brown fox
jumps over the lazy dog.</p>
<p class="whitespace-pre">The   quick brown fox
jumps over the lazy dog.</p>
<p class="whitespace-pre-line">The   quick brown fox
jumps over the lazy dog.</p>
<p class="whitespace-pre-wrap">The   quick brown fox
jumps over the lazy dog.</p>
<p class="whitespace-break-spaces">The   quick brown fox
jumps over the lazy dog.</p>
        `
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">whitespace-normal</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">whitespace-nowrap</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">whitespace-pre</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">whitespace-pre-line</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">whitespace-pre-wrap</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">whitespace-break-spaces</code> to control whitespace handling.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">whitespace-normal</small>
          <p class="whitespace-normal">The   quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">whitespace-nowrap</small>
          <p class="whitespace-nowrap">The   quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">whitespace-pre</small>
          <p class="whitespace-pre">The   quick brown fox
jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">whitespace-pre-line</small>
          <p class="whitespace-pre-line">The   quick brown fox
jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">whitespace-pre-wrap</small>
          <p class="whitespace-pre-wrap">The   quick brown fox
jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">whitespace-break-spaces</small>
          <p class="whitespace-break-spaces">The   quick brown fox
jumps over the lazy dog.</p>
        </div>
      </div>
      `
        }
    ]
};

export default whiteSpace;
<div className="whitespace-normal whitespace-nowrap whitespace-pre whitespace-pre-line whitespace-pre-wrap whitespace-break-spaces sr-only"></div>